import React, { Component, useState, useEffect } from "react";
import ReactDom from "react-dom";
import {
  Upload,
  message,
  List,
  Avatar,
  Select,
  Form,
  Input,
  Button,
  Modal,
  Switch,
  Spin,
  Tooltip,
  Space,
  Typography,
} from "antd";
import { InboxOutlined, LockOutlined, InfoOutlined } from "@ant-design/icons";
import axios from "axios";
import { ossApi as userApi, accessToken as fileToken } from "../../pages/asset/api/m";
import {
  wGetLocalStorage, wGetSessionStorage, wSetLocalStorage, wSetSessionStorage,
} from "../../utils/utils";
import { pageTitle } from "../../config/page-settings";
import { invokeFn } from "mazey";

export const getAccessToken = () => {
  const localToken = wGetLocalStorage("token");
  return fileToken || localToken || "";
};

const Login = (props) => {
  const { children, init } = props;
  // const loginSessionKey = `${key}_is_login`;
  const [ loading, setLoading ] = useState(true);
  const [ accessToken, setAccessToken ] = useState(getAccessToken());
  const [ passwordVisible, setPasswordVisible ] = useState(false);
  const [ password, setPassword ] = useState("");

  // useEffect(() => {
  //   // 如果缓存有 Token
  //   if (accessToken) {
  //     // 展示
  //     console.log('i am accessToken! useEffect []');
  //     loginSuccessInit();
  //   } else {
  //     showInputPassword();
  //   }
  // }, []);

  useEffect(() => {
    console.log("i am accessToken! useEffect [accessToken]");
    if (accessToken) {
      // console.log('i am accessToken! useEffect [accessToken]');
      loginSuccessInit();
    } else {
      showInputPassword();
    }
  }, [ accessToken ]);

  // 展示
  const loginSuccessInit = () => {
    console.log("loginSuccessInit start");
    cancelInputPassword();
    cancelLoading();
    // if (!wGetSessionStorage(loginSessionKey)) {
    // console.log('loginSuccessInit do');
    invokeFn(init);
    // wSetSessionStorage(loginSessionKey, '1');
    // }
    // console.log('hasLogin', wGetSessionStorage(loginSessionKey));
  };

  // 显示输入密码
  const showInputPassword = () => {
    setPasswordVisible(true);
  };

  // 取消输入密码
  const cancelInputPassword = () => {
    setPasswordVisible(false);
  };

  // 输入密码
  const inputPassword = e => {
    setPassword(e.target.value);
  };

  // 取消Loading
  const cancelLoading = () => {
    setLoading(false);
  };

  // 验证密码
  const verfPassword = async () => {
    message.loading({ content: "登录中", key: "login", duration: 60 });
    const res = await axios.post(userApi.login, {
      user_name: pageTitle,
      user_password: password,
    });
    if (!res) {
      message.error({ content: "网络错误", key: "login", duration: 2 });
      return;
    }
    const {
      data: { ret, message: serverMessage, data },
    } = res;
    if (ret === 0) {
      const { token } = data;
      wSetLocalStorage("token", token);
      setAccessToken(token);
      message.success({ content: serverMessage, key: "login", duration: 2 });
      return;
    }
    message.error({ content: serverMessage, key: "login", duration: 2 });
  };

  return (
    <div className='login-box'>
      <Spin spinning={loading} size="large" tip="登录中...">
        { loading ? <span className='login-text' style={{ height: "500px", display: "block" }}>&nbsp;</span> : children }
      </Spin>
      {/* 输入密码 */}
      <Modal
        title={`Hi ${pageTitle}，请输入密码`}
        visible={passwordVisible}
        onOk={verfPassword}
        okText="确认"
        onCancel={cancelInputPassword}
        cancelText="取消"
        maskClosable={false}
      >
        <Input placeholder="请输入用户名" size="large" value={pageTitle} hidden={true} />
        <Input
          placeholder="请输入密码"
          size="large"
          onChange={inputPassword}
          value={password}
          type="password"
          prefix={<LockOutlined className="site-form-item-icon" />}
        />
      </Modal>
    </div>
  );
};

export default Login;
